/**
 * 平台域名配置
 * 
 * 部署时修改项目根目录 .env.production 中的 VITE_APP_DOMAIN 即可
 * 例: VITE_APP_DOMAIN=mysaas.com
 */

/** 主平台域名（不带 www 前缀，不含协议） */
export const APP_DOMAIN: string = import.meta.env.VITE_APP_DOMAIN || 'fenleisaas.com';

/** 获取子域名完整 URL（HTTP） */
export function getSubdomainUrl(subdomain: string): string {
  return `http://${subdomain}.${APP_DOMAIN}`;
}

/** 获取子域名完整 URL（HTTPS） */
export function getSubdomainUrlHttps(subdomain: string): string {
  return `https://${subdomain}.${APP_DOMAIN}`;
}

/** 判断当前访问是否为主域名（含 localhost 开发环境） */
export function isMainDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.host.toLowerCase();
  // 开发环境
  if (host.includes('localhost') || host.includes('127.0.0.1')) return true;
  // 主域名（含 www）
  if (host === APP_DOMAIN || host === `www.${APP_DOMAIN}`) return true;
  return false;
}

/** 获取域名后缀描述（如 .fenleisaas.com） */
export function getDomainSuffix(): string {
  return `.${APP_DOMAIN}`;
}

/** 同 getDomainSuffix，别名 */
export const getDisplayDomainSuffix = getDomainSuffix;
